
import { Component, Inject, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { SearchScreenService } from "../Service/SearchScreen.Services";
import { BookingService } from "../../Booking/Service/Booking.Service";
import { BookingDataModel, FileSearch, UserData, BookingDoctorDataContainer, UserProfileModel, DashboardDataContainer, GeneralBookingModel, SlotBookingModel, DepartmentDataModel, PaymentDetails, keyvaluepair, Bookingkeyvaluepair } from "../../model/index"
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { IonRangeSliderComponent } from "ng2-ion-range-slider";
import { ModalComponent } from "../../shared/modeldialog/index";
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../Security/security.service';
import { CurrencyDetails } from "../../model/utilities/currencydetails";
declare var bookingGrid: any;
declare var require: any;
@Component({
    selector: 'MentisSoft-SearchScreen',
    template: require('../Template/SearchScreen.template.html'),
    providers: [CurrencyDetails, SearchScreenService, BookingService]
})

export class SearchScreenComponent implements AfterViewInit {
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    @ViewChild("slotAllotment") slotAllotment: ModalComponent;
    @ViewChild("paylaterPopup") paylaterPopup: ModalComponent;
    @ViewChild("BookingConfirmed") BookingConfirmed: ModalComponent;
    @ViewChild("EmailAlertpopup") EmailAlertpopup: ModalComponent;
    @ViewChild('advancedSliderElement') advancedSliderElement: IonRangeSliderComponent;

    @ViewChild("viewModelFile") viewModelFile: ModalComponent;

    depts: DepartmentDataModel[] = [];
    myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
    };
    fileSearch: FileSearch = new FileSearch();
    fileSearchRes: FileSearch[] = [];
    searchtext: string = "";
    IsSearchtext: boolean = false;
    IsNationalID: boolean = false;
    IsUserProfile: boolean = false;
    dashboardReports: DashboardDataContainer = new DashboardDataContainer();
    userprofile: UserProfileModel = new UserProfileModel();

    slotBookingFailed: boolean = false;
    slotMessage: string = "If a slot is chosen, please make payment within 5 minutes else the slot will remain unbooked."
    message: string = "";
    selectedSlotDrCode: string;
    timeSlotsArray: Bookingkeyvaluepair[] = [];
    totalTimeSlots: SlotBookingModel[] = [];
    isValid = true;
    IsConfirmPay: boolean = false;
    radioText: number = 0;
    loading = false;
    chosenSlotValue: number;
    generalBooking: GeneralBookingModel = new GeneralBookingModel();
    slotBooking: SlotBookingModel = new SlotBookingModel();
    IsBookingConfirmed: boolean;
    payment: PaymentDetails[] = [];
    Redirect: string[] = [];
    redirectString: string;
    Querynumber: string;
    QueryIsPayment: string;
    CurrencyValue: string;
    NegativeConsultationCharge: boolean = false;
    TokenNegativeConsultationCharge: boolean = false;
    tokenNo: string = "";
    selectedSlotClass: string;
    inProgressSlot: string;
    scheduledStartTime: string;
    scheduledEndTime: string;
    enableJnhPopup: string;
    enableHadiPopup: string;
    DoctorsSlotTiming: string;
    BookingType: string = "";
    PaymentGatewayType: string = "";
    payLaterStatus: string = "";
    paylaterBookingStatus: boolean = false;
    isSlotValueChosen: boolean = false;
    slotErrorMessage: string = "NO";
    enableSaving: string = "YES";
    patientSex: string = "";
    patientAge: number;
    emailMsg: string = "";
    IsAdminUser: boolean = false;
    patientId: string = "";
    patientName: string = "";
    IsPatientSearch: boolean = false;
    errMsg: string = "";
    searchNationalID: string = "";
    searchInsurance: string = "";
    FollowerrMsg: string = "";
    IsFollowTest: boolean = false;
    ngOnInit() {
        this.IsAdminUser = JSON.parse(localStorage.getItem("ISAdmin"));
        this.LoadDepartments();
    }
    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private router: Router, private route: ActivatedRoute, private _bookingService: BookingService, private _SearchScreenService: SearchScreenService, private _titleService: Title,
        @Inject(CurrencyDetails) private _CurrencyDetails: CurrencyDetails) {
        bookingGrid = this;
        this.bookingFilter = new BookingDataModel();
        this.bookingFilter.DEPT_CODE = "0";
        this.Querynumber = router.parseUrl(router.url).queryParams["Id"];
        if (this.Querynumber == "" || this.Querynumber == undefined) {
            this.Querynumber = this.router.parseUrl(this.router.url).queryParams["result"];
            this.searchtext = this.Querynumber;
            this.patientId = this.Querynumber;
        }
    }

    ngAfterViewInit(): void {
        this.IsAdminUser = JSON.parse(localStorage.getItem("ISAdmin"));
        if (this.IsAdminUser == true) {
            if (localStorage.getItem("AdminPatientId") != undefined && localStorage.getItem("AdminPatientId") != null)
                this.patientId = localStorage.getItem("AdminPatientId");
            if (localStorage.getItem("AdminPatientName") != undefined && localStorage.getItem("AdminPatientName") != null)
                this.patientName = localStorage.getItem("AdminPatientName");
            if (this.patientName == "null")
                this.patientName = "";
        }
        $('#overlay').hide();
        this._titleService.setTitle("Bookings");
        this.BookingType = localStorage.getItem("BookingType");

        if (this.Querynumber != "" && this.Querynumber != undefined) {
            this.loading = true;
            this.searchtext = this.Querynumber;
            this.patientId = this.Querynumber;
            this.LoadingAfterPayment(this.Querynumber);
            this.LoadBookingReports();
            this.loading = false;
        }
    }
    SelectPatientId(searchPatientID, nationalID, isInsuredFlag) {
        this.searchInsurance = "";
        this.FollowerrMsg = "";
        this.searchInsurance = "";
        this.errMsg = "";
        this._SearchScreenService.GetLoggedInUserProfile(this._SecurityService.pid, this._SecurityService.authentication, searchPatientID, this._SecurityService.IsAdminUser)
            .subscribe(
            p => {
                if (p != null && p.SessionTimeout != "Session Expired") {
                    this._SecurityService.errorMessage = "";
                    this.userprofile.age = p.age;
                    this.userprofile.dob = p.dob;
                    this.userprofile.Email = p.Email;
                    this.userprofile.mobile = p.mobile;
                    this.userprofile.PatientID = p.PatientID;
                    this.userprofile.RegistrationDate = p.RegistrationDate;
                    this.userprofile.SponsorCode = p.SponsorCode;
                    this.userprofile.UserName = p.UserName;
                    this.userprofile.Sex = p.Sex;
                    this.userprofile.ImageByte = p.ImageByte;
                    this.userprofile.SponsorName = p.SponsorName;
                    this.userprofile.PolicyNo = p.PolicyNo;
                    this.userprofile.Validity = p.Validity;
                    if (nationalID != null && nationalID != undefined && nationalID != "" && isInsuredFlag == 0) {
                        this.IsNationalID = true;
                        this.IsUserProfile = true;
                        this.LoadDepartments();
                        this.LoadBookingReports();
                        this.viewModelFile.close();
                    }
                    else {
                        this.IsNationalID = true;
                        this.IsUserProfile = true;
                        this.viewModelFile.close();
                    }
                    if (isInsuredFlag == 1) {

                        this.searchInsurance = "Please visit our front office and collect your Insurance card.";
                    }
                    if (nationalID == null && nationalID == undefined) {

                        this.searchNationalID = "National id is not registered. Please visit our front office and scan your national id card.";
                    }

                }

                else if (p == null || p.SessionTimeout == "Session Expired") {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);

                }
            },
            err => {

                console.log("Error while validating...");
            }

            );
    }

    FileSearch(radioText) {
        this.loading = true;
        this.depts = [];
        this.dataSource = [];
        this.fileSearch.PatientId = "";
        this.fileSearch.MobileNumber = "";
        this.fileSearch.NationalId = "";
        this.searchInsurance = "";
        this.FollowerrMsg = "";
        this.searchInsurance = "";
        this.errMsg = "";
        this.userprofile = new UserProfileModel();
        this.buildGrid(this.dataSource);
        if (this.searchtext == "" || this.searchtext == undefined || this.searchtext == null) {
            this.IsSearchtext = true;
            this.errMsg = "Please enter the required mandatory(*) filed.";
            this.loading = false;
        }
        else {
            this.IsSearchtext = false;
            if (radioText == 0)
                this.fileSearch.PatientId = this.searchtext;
            else if (radioText == 1)
                this.fileSearch.MobileNumber = this.searchtext;
            else
                this.fileSearch.NationalId = this.searchtext;
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);

            this._SearchScreenService.getSearchFileDashboard(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser, this.fileSearch)
                .subscribe(
                p => {
                    if (p != null && p.ValidUser && p.SessionTimeout != "Session Expired") {
                        if (!p.IsSearchPatientValid) {
                            this.IsSearchtext = true;
                            this.errMsg = "Search Patient ID is not valid.";
                            this.IsUserProfile = false;

                        }
                        else {

                            if (p.fileSearch.length == 0) {
                                this.IsSearchtext = true
                                if (radioText == 0) {
                                    if (p.IsValidPatient == true) {
                                        this.FollowerrMsg = "";
                                        this.errMsg = "The search Patient not eligible for follow visit. Please visit our front office";
                                        this.IsUserProfile = false;
                                    }
                                    else {
                                        this.FollowerrMsg = "";
                                        this.errMsg = "Search Patient ID is not valid.";
                                        this.IsUserProfile = false;
                                    }
                                }
                                if (radioText == 1) {
                                    if (p.IsValidPatient == true) {
                                        this.FollowerrMsg = "";
                                        this.errMsg = "The search Patient not eligible for follow visit. Please visit our front office";
                                        this.IsUserProfile = false;
                                    }
                                    else {
                                        this.FollowerrMsg = "";
                                        this.errMsg = "Search Mobile number is not valid.";
                                        this.IsUserProfile = false;
                                    }
                                }
                                if (radioText == 2) {
                                    if (p.IsValidPatient == true) {
                                        this.FollowerrMsg = "";
                                        this.errMsg = "The search Patient not eligible for follow visit. Please visit our front office";
                                        this.IsUserProfile = false;
                                    }
                                    else {
                                        this.FollowerrMsg = "";
                                        this.errMsg = "Search National Id is not valid.";
                                        this.IsUserProfile = false;
                                    }
                                }
                            }
                            else {
                                this.fileSearchRes = p.fileSearch;
                                this.patientId = this.fileSearchRes[0].PatientId;
                                if (radioText == 1) {
                                    if (p.fileSearch.length > 1)
                                        this.viewModelFile.open();
                                    else {
                                        if (this.fileSearchRes[0].FollowVistCount > 0)
                                            this.SelectPatientId(this.fileSearchRes[0].PatientId, this.fileSearchRes[0].NationalId, this.fileSearchRes[0].IsInsuranceFlag);
                                        else {
                                            this.IsFollowTest = true;
                                            this.searchNationalID = "";
                                            this.FollowerrMsg = "The search Patient not eligible for follow visit. Please visit our front office";
                                            this.IsUserProfile = false;
                                        }
                                    }
                                }
                                else {
                                    if (this.fileSearchRes[0].FollowVistCount > 0)
                                        this.SelectPatientId(this.fileSearchRes[0].PatientId, this.fileSearchRes[0].NationalId, this.fileSearchRes[0].IsInsuranceFlag);
                                    else {
                                        this.IsFollowTest = true;
                                        this.searchNationalID = "";
                                        this.FollowerrMsg = "The search Patient not eligible for follow visit. Please visit our front office";
                                        this.IsUserProfile = false;
                                    }
                                }
                            }
                        }
                        this.loading = false;

                    }
                    else if (!p.ValidUser || p.SessionTimeout == "Session Expired") {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                        this.loading = false;
                    }

                },
                err => {
                    this.loading = false;
                    console.log("Error while validating...");
                }

                );
        }
    }

    MobilePatientId(searchPatientID, nationalID) {
        this.fileSearch = new FileSearch();
        this.fileSearch.PatientId = searchPatientID;
        this._SearchScreenService.getSearchFileDashboard(this._SecurityService.pid, this._SecurityService.authentication, searchPatientID, this._SecurityService.IsAdminUser, this.fileSearch)
            .subscribe(
            p => {
                if (p != null && p.ValidUser && p.SessionTimeout != "Session Expired") {
                    if (!p.IsSearchPatientValid) {
                        this.IsSearchtext = true;
                        this.errMsg = "Search Patient ID is not valid.";

                    }
                    else {

                        if (p.fileSearch.length == 0) {
                            this.IsSearchtext = true
                            this.errMsg = "Search Patient ID is not valid.";
                        }
                        else {
                            this.fileSearchRes = p.fileSearch;
                            this.patientId = this.fileSearchRes[0].PatientId;
                            if (this.fileSearchRes[0].FollowVistCount > 0)
                                this.SelectPatientId(this.fileSearchRes[0].PatientId, this.fileSearchRes[0].NationalId, this.fileSearchRes[0].IsInsuranceFlag);
                            else {
                                this.IsNationalID = false;
                                this.IsFollowTest = true;
                                this.IsUserProfile = false;
                                this.searchNationalID = "";
                                this.FollowerrMsg = "The search Patient not eligible for follow visit. Please visit our front office";
                            }
                        }
                    }
                    this.viewModelFile.close();
                }
                else if (!p.ValidUser || p.SessionTimeout == "Session Expired") {
                    this.viewModelFile.close();
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }

            },
            err => {

                console.log("Error while validating...");
            }

            );
    }
    BackToLogin() {
        this.router.navigate(["/Language"]);
    }
    year = new Date();
    appDate: Object = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
    workingDays: any = [{ val: 9, day: "Any" }, { val: 1, day: "Mon" }, { val: 2, day: "Tue" }, { val: 3, day: "Wed" }, { val: 4, day: "Thu" }, { val: 5, day: "Fri" }, { val: 6, day: "Sat" }, { val: 7, day: "Sun" }];

    dataSource: BookingDataModel[] = [];
    bookingFilter: BookingDataModel;


    columns: any[] = [];
    month = ("0" + (this.year.getMonth() + 1)).slice(-2);
    date: string = ("0" + this.year.getDate()).slice(-2) + "/" + this.month + "/" + this.year.getFullYear();
    data: BookingDoctorDataContainer;
    clickedDate: string;
    advancedSlider = { name: "Advanced Slider", onUpdate: undefined, onFinish: undefined };
    activeTab: number = 9;

    activebutton: number = this.year.getDay();
    update(slider, event) {

        slider.onUpdate = event;
    }

    finish(slider, event) {

        slider.onFinish = event;
        if (event) {
            this.bookingFilter.FromTime = event.from + ":00";
            this.bookingFilter.ToTime = event.to + ":00";
            this.LoadFilterReports();
        }
    }

    setTab(val: number) {
        if (val != 9) {
            var d = new Date();
            if (d.getDay() > val) {
                d.setDate(d.getDate() + (7 - d.getDay()) + val)
            }
            else {
                d.setDate(d.getDate() + (val - d.getDay()));
            }
            this.appDate = { date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() } };


            this.activebutton = val;
            this.clickedDate = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
            this.bookingFilter.FromDate = this.clickedDate;
            this.bookingFilter.DAYS = val.toString();

        }
        else {
            this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
            this.activebutton = val;
            this.bookingFilter.FromDate = this.date;
        }
        this.LoadFilterReports();

    }

    isActive(val: number, val1: number): boolean {
        if (val1 == val)
            return true
        return false;
    }

    showBookingSlots(drCode) {
        this.loading = true;
        if (this.IsAdminUser == true) {

            this.IsPatientSearch == false;
            this.slotErrorMessage = "NO";
            this.isSlotValueChosen = false;
            this.timeSlotsArray = [];
            this.selectedSlotClass = "";
            this.selectedSlotDrCode = drCode;
            this.CurrencyValue = localStorage.getItem("CurrencySymbol");

            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.dataSource[i].DoctorCode == drCode) {
                    if (this.bookingFilter.FromDate == undefined) {
                        this.bookingFilter.FromDate = this.date;
                    }
                    if (this.bookingFilter.ToTime == undefined) {
                        this.bookingFilter.ToTime = "23:00";
                    }
                    if (this.bookingFilter.FromTime == undefined) {
                        this.bookingFilter.FromTime = "09:00";
                    }
                    this.generalBooking.date = this.bookingFilter.FromDate;
                    this.generalBooking.department = this.dataSource[i].DeptName;
                    this.generalBooking.departmentId = this.dataSource[i].DEPT_CODE;
                    this.generalBooking.doctorId = this.dataSource[i].DoctorCode;
                    this.generalBooking.doctorName = this.dataSource[i].DoctorName;
                    this.generalBooking.Id = this.patientId;
                    this.generalBooking.speciality = this.dataSource[i].Speciality;
                    this.generalBooking.scheduledEndTime = this.bookingFilter.ToTime;
                    this.generalBooking.scheduledStartTime = this.bookingFilter.FromTime;
                    this.generalBooking.dayCode = this.activebutton;
                    this.generalBooking.ImageByte = this.dataSource[i].ImageByte;
                    this.generalBooking.SlotPeriod = this.dataSource[i].SlotPeriod;
                    this.generalBooking.StartTime = this.dataSource[i].StartTime;
                    this.generalBooking.EndTime = this.dataSource[i].EndTime;
                    this.generalBooking.SessionCode = this.dataSource[i].SessionCode;
                    this.generalBooking.VisitNo = this.dataSource[i].VisitNo;
                    this.generalBooking.VistiDate = this.dataSource[i].VistiDate;
                    this.generalBooking.designation = this.dataSource[i].Designation;
                    this.generalBooking.Qualification = this.dataSource[i].Qualification;
                    if (this.BookingType == "SLOT") {
                        this.scheduledEndTime = this.dataSource[i].EndTime.toString().split('T')[1].slice(0, 5);
                        this.scheduledStartTime = this.dataSource[i].StartTime.toString().split('T')[1].slice(0, 5);


                        this.DoctorsSlotTiming = this.dataSource[i].DoctorTime;

                    }
                }
            }
            this._bookingService.getConfirmBookingStatus(this.generalBooking, userData)
                .subscribe(
                p => {
                    if (p != null && p.SessionExpiry && p.SessionTimeout != "Session Expired") {
                        this._SecurityService.errorMessage = "";
                        if (p.doctorStatus == "YES") {
                            this.generalBooking.totalTimeSlots = p.totalTimeSlots;

                            /* Role ID is 2  -Follow up appointment should not collect Consultation fees from follow up patient */
                            this.generalBooking.consultationFee = "0.00";
                           this.generalBooking.ServiceCode = p.ServiceCode
                            this.generalBooking.ServiceName = p.ServiceName;
                            this.isValid = true;
                            this.IsConfirmPay = true;
                            if (this.IsConfirmPay == true)
                                this.payLaterStatus = p.PaymentLaterStatus;
                            else
                                this.payLaterStatus = "TRUE";
                            if (this.BookingType == "SLOT") {
                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                this.viewModelPopup.open();
                                this.enableHadiPopup = "YES";
                            }
                            else {
                                this.isSlotValueChosen = true;
                                this.viewModelPopup.open();
                                this.enableJnhPopup = "YES";
                            }
                        }
                        else {
                            this.isValid = false;
                        }
                        this.loading = false;
                    }
                    else if (p.SessionExpiry || p.SessionTimeout == "Session expired") {
                        this.loading = false;
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");

                });


        }
        else {
            this.slotErrorMessage = "NO";
            this.isSlotValueChosen = false;
            this.timeSlotsArray = [];
            this.selectedSlotClass = "";
            this.selectedSlotDrCode = drCode;
            this.CurrencyValue = localStorage.getItem("CurrencySymbol");

            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.dataSource[i].DoctorCode == drCode) {
                    if (this.bookingFilter.FromDate == undefined) {
                        this.bookingFilter.FromDate = this.date;
                    }
                    if (this.bookingFilter.ToTime == undefined) {
                        this.bookingFilter.ToTime = "23:00";
                    }
                    if (this.bookingFilter.FromTime == undefined) {
                        this.bookingFilter.FromTime = "09:00";
                    }
                    this.generalBooking.date = this.bookingFilter.FromDate;
                    this.generalBooking.department = this.dataSource[i].DeptName;
                    this.generalBooking.departmentId = this.dataSource[i].DEPT_CODE;
                    this.generalBooking.doctorId = this.dataSource[i].DoctorCode;
                    this.generalBooking.doctorName = this.dataSource[i].DoctorName;
                    this.generalBooking.Id = this._SecurityService.pid;
                    this.generalBooking.speciality = this.dataSource[i].Speciality;
                    this.generalBooking.scheduledEndTime = this.bookingFilter.ToTime;
                    this.generalBooking.scheduledStartTime = this.bookingFilter.FromTime;
                    this.generalBooking.dayCode = this.activebutton;
                    this.generalBooking.ImageByte = this.dataSource[i].ImageByte;
                    this.generalBooking.SlotPeriod = this.dataSource[i].SlotPeriod;
                    this.generalBooking.StartTime = this.dataSource[i].StartTime;
                    this.generalBooking.EndTime = this.dataSource[i].EndTime;
                    this.generalBooking.SessionCode = this.dataSource[i].SessionCode;
                    this.generalBooking.designation = this.dataSource[i].Designation;
                    this.generalBooking.Qualification = this.dataSource[i].Qualification;
                    if (this.BookingType == "SLOT") {
                        this.scheduledEndTime = this.dataSource[i].EndTime.toString().split('T')[1].slice(0, 5);
                        this.scheduledStartTime = this.dataSource[i].StartTime.toString().split('T')[1].slice(0, 5);


                        this.DoctorsSlotTiming = this.dataSource[i].DoctorTime;

                    }
                }
            }
            this._bookingService.getConfirmBookingStatus(this.generalBooking, userData)
                .subscribe(
                p => {
                    if (p != null && p.SessionExpiry && p.SessionTimeout != "Session Expired") {
                        this._SecurityService.errorMessage = "";
                        if (p.doctorStatus == "YES") {
                            this.generalBooking.totalTimeSlots = p.totalTimeSlots;
                            /* Role ID is 2  -Follow up appointment should not collect Consultation fees from follow up patient */
                            this.generalBooking.consultationFee = "0.00";
                            
                            this.generalBooking.ServiceCode = p.ServiceCode
                            this.generalBooking.ServiceName = p.ServiceName;
                            this.isValid = true;
                            this.IsConfirmPay == true
                            if (this.IsConfirmPay == true)
                                this.payLaterStatus = p.PaymentLaterStatus;
                            else
                                this.payLaterStatus = "TRUE";
                            if (this.BookingType == "SLOT") {
                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                this.viewModelPopup.open();
                                this.enableHadiPopup = "YES";
                            }
                            else {
                                this.isSlotValueChosen = true;
                                this.viewModelPopup.open();
                                this.enableJnhPopup = "YES";
                            }
                        }
                        else {
                            this.isValid = false;
                        }
                        this.loading = false;
                    }
                    else if (p.SessionExpiry || p.SessionTimeout == "Session expired") {
                        this.loading = false;
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });


        }

    }

    LoadingAfterPayment(Querynumber: string) {
        this.loading = true;
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this._bookingService.AfterPaymentConfirmation(Querynumber, userData)
            .subscribe(
            s => {
                if (s != null && s.SessionTimeout != "Session Expired") {
                    if (s.isValid == true) {
                        this.IsBookingConfirmed = true;
                        this.isValid = false;
                        this.viewModelPopup.close();
                        this.BookingConfirmed.open();
                        this.NegativeConsultationCharge = false;
                    }
                    else {
                        this.IsBookingConfirmed = false;
                        this.BookingConfirmed.open();
                        this.isValid = false;
                        this.NegativeConsultationCharge = false;
                    }
                }
                else {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
                this.loading = false;
            },
            err => {
                console.log("Error while getting data...");
                this.loading = false;
            });
    }

    ChosenSlotValue(slotValue) {
        this.loading = true;
        if (this.enableSaving == "YES") {
            this.isSlotValueChosen = true;
            this.slotErrorMessage = "NO";
            if (slotValue.value != "B" && slotValue.value != "L" && this.BookingType == "SLOT") {
                if (this.IsAdminUser == true) {
                    if (this.Querynumber != "" && this.Querynumber != undefined) {
                        this.patientId = this.Querynumber;
                        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                    }
                    else {
                        if (this.patientId == "" || this.patientId == undefined || this.patientId == null) {

                            this.emailMsg = "Before Choose the Slot Please enter the Patient id";
                            this.EmailAlertpopup.open();
                            this.loading = false;
                        }
                        else {
                            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                        }

                    }

                }
                else {
                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
                }


                this.generalBooking.scheduledStartTime = slotValue.key;
                this.generalBooking.SessionCode = slotValue.SessionCode;
                this.selectedSlotClass = this.generalBooking.scheduledStartTime;
                for (var i = 0; i < this.timeSlotsArray.length; i++) {
                    if (this.timeSlotsArray[i].key == slotValue.key) {
                        this.chosenSlotValue = i;
                    }
                }
                if (this.chosenSlotValue != (this.timeSlotsArray.length - 1)) {
                    this.generalBooking.scheduledEndTime = this.timeSlotsArray[this.chosenSlotValue + 1].key;
                }
                else {
                    this.generalBooking.scheduledEndTime = this.scheduledEndTime;
                }
                this.generalBooking.BookingStatus = "B";
                this._bookingService.updateChosenSlot(this.generalBooking, userData)
                    .subscribe(
                    p => {
                        if (p.SessionTimeout != "Session Expired" && p != null) {
                            if (p.length != 0) {
                                this.isSlotValueChosen = false;
                                this.message = p[0];
                                this.slotBookingFailed = true;
                                this.selectedSlotClass = "";
                                this.slotAllotment.open();
                            }
                            else {
                                this.isSlotValueChosen = true;
                                this.slotBookingFailed = false;
                                this.slotAllotment.close();
                            }
                            this.loading = false;
                        }
                        else {
                            this.loading = false;
                            this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                            this.router.navigate(["/Login"]);
                        }
                    });
            }
        }
    }

    closeSlotAllotmentpopup() {
        this.slotAllotment.close();
    }

    SaveAppointment() {
        this.tokenNo = "";
        if (this.isSlotValueChosen) {
            this.slotErrorMessage = "NO";
            this.loading = true;
            if (this.IsAdminUser == true) {
                if (this.Querynumber != "" && this.Querynumber != undefined) {
                    this.patientId = this.Querynumber;
                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                }
                else {
                    if (this.patientId == "" || this.patientId == undefined || this.patientId == null) {

                        this.emailMsg = "Please enter the Patient id";
                        this.EmailAlertpopup.open();
                        this.loading = false;
                    }
                    else {
                        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                    }

                }

            }
            else {
                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            }
            this.generalBooking.ScreenName = "SearchScreen";

            this._bookingService.SaveApointmentRequest(this.generalBooking, userData)
                .subscribe(
                p => {
                    if (p.ErrorMessage != null && p.ErrorMessage.search("Slot is booked/blocked. Please refresh the screen") != -1) {


                        this.isSlotValueChosen = false;
                        this.message = "This slot time is already booked. Please chose another slot timing.";
                        this.slotBookingFailed = true;
                        this.selectedSlotClass = "";
                        this.slotAllotment.open();
                        this.loading = false;
                    }
                    else {
                        if (p.ErrorMessage != null && p.ErrorMessage != "The Pay Page is created." && p.ErrorMessage.search("Slot is booked/blocked. Please refresh the screen") == -1) {
                            this.BookingConfirmed.open();
                            this.TokenNegativeConsultationCharge = true;
                            this.NegativeConsultationCharge = true;
                            this.IsBookingConfirmed = true;
                            this.loading = false;
                        }
                        else if (p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                            if (p != null) {
                                this._SecurityService.errorMessage = "";
                                this.redirectString = p.PaymentRedirectSiteUrl;

                                if (p.AppointmentResult == "Success") {
                                    this.tokenNo = p.TokenNo;
                                    this.BookingConfirmed.open();
                                    this.NegativeConsultationCharge = false;
                                    this.IsBookingConfirmed = true;
                                    this.loading = false;
                                    this.LoadDepartments();
                                    this.LoadBookingReports();
                                }
                                else {
                                    this.BookingConfirmed.open();
                                    this.IsBookingConfirmed = false;
                                    this.loading = false;
                                }
                                
                            }
                            else {
                                this.NegativeConsultationCharge = false;
                                this.IsBookingConfirmed = false;
                                this.isValid = true;
                                this.loading = false;
                            }
                        }


                        else if (!p.sessionExpiry) {
                            this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                            this.router.navigate(["/Login"]);
                            this.loading = false;
                        }
                    }
                },
                err => {
                    console.log("Error while getting data...");
                });
        }

        else {
            this.slotErrorMessage = "YES";
        }
    }

    onDateChanged(event: IMyDateModel) {
        if (event != undefined) {

            var dt = new Date(event.date.year, event.date.month - 1, event.date.day);

            this.activebutton = dt.getDay();
            if (this.activebutton == 0)
                this.activebutton = 7;
            this.bookingFilter.FromDate = event.formatted.toString();
            this.bookingFilter.FromDate = this.bookingFilter.FromDate.replace(".", "/");
        }
        this.LoadFilterReports();
    }

    onDepartmentchange(event) {
        if (this.patientSex == "Male" && event == "100305") {
            this.enableSaving = "NO";
        }

        else if (event == "100313" && this.patientAge > 15) {
            this.enableSaving = "NO";
        }

        else {
            this.enableSaving = "YES";
        }
        this.LoadFilterReports();
    }

    getElement(data) {
        if (typeof (data) == 'string') {
            return document.getElementById(data);
        }
        if (typeof (data) == 'object' && data instanceof Element) {
            return data;
        }
        return null;
    }

    buildBookingfilter(): UserData {
        if (this.bookingFilter.FromDate == undefined) {
            this.bookingFilter.FromDate = this.date;
        }
        if (this.bookingFilter.ToTime == undefined) {
            this.bookingFilter.ToTime = "23";
        }
        if (this.bookingFilter.FromTime == undefined) {
            this.bookingFilter.FromTime = "09";
        }
        if (this.Querynumber != "" && this.Querynumber != undefined) {
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.Querynumber, this._SecurityService.IsAdminUser);
        }
        else {
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.fileSearch.PatientId, this._SecurityService.IsAdminUser);
        }
        if (this.bookingFilter) {
            userData.DayCode = this.activebutton.toString();
            userData.DateFrom = this.bookingFilter.FromDate;
            userData.DepartmentID = this.bookingFilter.DEPT_CODE;
            userData.FromTime = this.bookingFilter.FromTime;
            userData.ToTime = this.bookingFilter.ToTime;
            userData.DayCode = this.activebutton.toString();
            userData.DepartmentID = this.bookingFilter.DEPT_CODE;
        }
        return userData;
    }

    LoadDepartments() {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        if (this.Querynumber != "" && this.Querynumber != undefined) {
            this._SearchScreenService.getDepartmentsByPatient(userData, this.Querynumber)
                .subscribe(
                p => {
                    if (p.SessionTimeout != "Session Expired" && p.SessionTimeout != "Session Expired") {
                        this.depts = p.Departments;
                        this.BookingType = p.BookingType;
                        this.patientSex = p.PatientSex;
                        this.patientAge = p.PatientAge;
                        this.PaymentGatewayType = p.PaymentGatewayType;

                    }
                    else {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);

                    }
                },
                err => {

                    console.log("Error while getting department data...");
                });
        }
        else {
            this._SearchScreenService.getDepartmentsByPatient(userData, this.userprofile.PatientID)
                .subscribe(
                p => {
                    if (p.SessionTimeout != "Session Expired" && p.SessionTimeout != "Session Expired") {
                        this.depts = p.Departments;
                        this.BookingType = p.BookingType;
                        this.patientSex = p.PatientSex;
                        this.patientAge = p.PatientAge;
                        this.PaymentGatewayType = p.PaymentGatewayType;

                    }
                    else {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);

                    }
                },
                err => {

                    console.log("Error while getting department data...");
                });
        }

    }

    LoadBookingReports() {
        this.loading = true;
        this.dataSource = [];
        if (this.Querynumber != "" && this.Querynumber != undefined) {
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.Querynumber, this._SecurityService.IsAdminUser);
        }
        else {
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.userprofile.PatientID, this._SecurityService.IsAdminUser);
        }
        userData.FromTime = "9:00";
        userData.ToTime = "23:00";
        userData.DateFrom = this.date;
        userData.DepartmentID = "0";
        userData.DayCode = this.activebutton.toString();


        this._SearchScreenService.getBookingReportsByPatient(userData)
            .subscribe(
            p => {
                if (p != null && p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                    this.dataSource = p.BookingList;
                    this.buildGrid(this.dataSource);

                    this._SecurityService.errorMessage = "";

                }
                else if (!p.sessionExpiry) {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);

                }

            },
            err => {

                console.log("Error while getting booking data...");
            });
    }

    GetSplittedTimeSlots(timeslotArray, drCode) {
        this.selectedSlotDrCode = drCode;
        for (var i = 0; i < timeslotArray.length; i++) {
            let kv: Bookingkeyvaluepair = new Bookingkeyvaluepair();
            kv.key = timeslotArray[i].SlotTime;
            kv.value = timeslotArray[i].SlotStatusValue;
            kv.slotMessage = this.slotMessage;
            kv.SessionCode = timeslotArray[i].SessionCode;
            this.timeSlotsArray.push(kv);
        }
    }

    LoadFilterReports() {
        var userData: UserData = this.buildBookingfilter();
        this.loading = true;

        this._SearchScreenService.getFilterReports(userData)
            .subscribe(
            p => {

                if (p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                    this.dataSource = p.BookingList;
                    this.buildGrid(this.dataSource);
                    this.loading = false;
                }
                else {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                    this.loading = false;
                }
            },
            err => {
                this.loading = false;
                console.log("Error while getting booking data...");
            });
    }

    public buildGrid(Data) {
        try {
            this.loading = true;

            this.buildColumn();

            var dgrid = jQuery("#grdBookings").data("kendoGrid");
            if (dgrid) {
                $('#grdBookings').data().kendoGrid.destroy();
                $('#grdBookings').empty();
            }
            jQuery('#grdBookings').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [5, 10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,

                columns: this.columns,
                filterMenuInit: function (e) {
                    if (e.field != "SubmissionID" && e.field != "NameInsuredOrTreatyTitle") {
                        var filterMultiCheck = e.sender.thead.find("[data-field=" + e.field + "]").data("kendoFilterMultiCheck");
                        filterMultiCheck.container.empty();
                        var chkSourceData = filterMultiCheck.checkSource.data();

                        chkSourceData.sort(function (a: any, b: any) {
                            var sortStatus = 0;

                            if (a[e.field].toLowerCase() < b[e.field].toLowerCase()) {
                                sortStatus = -1;
                            } else if (a[e.field].toLowerCase() > b[e.field].toLowerCase()) {
                                sortStatus = 1;
                            }

                            return sortStatus;
                        });

                        filterMultiCheck.checkSource.data(chkSourceData.toJSON());
                        filterMultiCheck.createCheckBoxes();
                    }
                },

                dataBinding: this.databinding,

                dataSource: {
                    data: Data,

                    pageSize: Data != null ? 10 : 0,
                    sort: [{
                        field: "color",
                        dir: "desc"
                    }],
                },
            });
            jQuery("#grdBookings").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdBookings").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
            this.loading = false;
        }
        catch (ex) {
            this.loading = false;
            this.handleError(ex);
        }
    }

    buildColumn(): void {

        this.columns = [
            {
                field: "DEPT_CODE",
                title: " ",
                template: kendo.template("#=this.buildBookingReportRow(DoctorName, DoctorCode, DEPT_CODE, SLOT, DAYS, Qualification, Designation, Speciality, ImageByte, DeptName,color,VistiDate)#").bind(this)
            }
        ];
    }

    buildBookingReportRow(DoctorName, DoctorCode: string, DEPT_CODE, SLOT, DAYS, Qualification, Designation, Speciality, ImageByte, DeptName, color, VistiDate) {

        var dept = DEPT_CODE;

        var drCode = DoctorCode;

        var Img = "data:image/JPEG;base64," + ImageByte;
        var doctorColor = color;


        var l1 = "<div class='visit_wrap doc_deta_wrap'>";
        var l2 = "    <div class='doc-img-wrap'>  <img src=" + Img + " /> </div>";
        var l3 = "    <div class='doctor_date graybg pad_le130'>";
        var l4 = "        <span class='doc-name green_text'> <strong>" + DoctorName + " </strong> , ( " + DeptName + " ) </span>";
        var l44 = "        <span class='doc-name green_text'> <strong style='color:red'>" + DoctorName + " </strong> , ( " + DeptName + " ) </span>";
        var l5 = "        <span class='pull-right font13'></span>";
        var l6 = "    </div>";
        var l7 = "    <div class='doc_short_desc pad_le130'>";
        var l8 = "        <span class='doc-desc'>" + Qualification + "   " + Designation + " </span> ";
        var l9 = "    </div>";
        var l10 = "    <div class='tot_slot_book pad_le130'>";
        var l11 = "        <span class='ttlslot green_text'>" + SLOT + "</span>";
        var l12 = "        <span class='availdays font13'> " + DAYS + " </span>";
        var l13 = "        <span class='pull-right green-bg bookbtn'  onclick=bookingGrid.showBookingSlots('" + DoctorCode + "')> <i class='fa fa-calendar-plus-o' aria-hidden='true'></i> Book Appointment </span>";
        var l16 = "        <span class='pull-right green-bg bookbtn disableBtn'> <i class='fa fa-calendar-plus-o' aria-hidden='true'></i> Book Appointment </span>";
        var l14 = "    </div>";
        var l15 = "</div>"
        if (doctorColor != null && doctorColor != "" && doctorColor != undefined) {
            if (this.activebutton == 9)
                return l1 + l2 + l3 + l44 + l5 + l6 + l7 + l8 + l9 + l10 + l11 + l12 + l16 + l14 + l15;
            else
                return l1 + l2 + l3 + l44 + l5 + l6 + l7 + l8 + l9 + l10 + l11 + l12 + l13 + l14 + l15;
        }
        else {
            if (this.activebutton == 9)
                return l1 + l2 + l3 + l4 + l5 + l6 + l7 + l8 + l9 + l10 + l11 + l12 + l16 + l14 + l15;
            else
                return l1 + l2 + l3 + l4 + l5 + l6 + l7 + l8 + l9 + l10 + l11 + l12 + l13 + l14 + l15;
        }
    }

    databinding(e: any) {
        try {
            var grid = jQuery("#grdBookings").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "5", value: 5 }, { text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {

        }
    }

    ScheduledAppointments() {
        this.router.navigate(["/Appointments"]);
    }
    PaymentFailedOk() {
        this.BookingConfirmed.close();
        this.viewModelPopup.close();
    }

    private handleError(error: any) {
        console.log("error : " + error);
    }

    Emailpopup() {
        this.EmailAlertpopup.close();
        this.viewModelPopup.close();
    }

    PayLaterAppointmentSave() {
        if (this.isSlotValueChosen) {
            this.slotErrorMessage = "NO";
            if (this.IsAdminUser == true) {
                if (this.Querynumber != "" && this.Querynumber != undefined) {
                    this.patientId = this.Querynumber;
                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                }
                else {
                    if (this.patientId == "" || this.patientId == undefined || this.patientId == null) {

                        this.emailMsg = "Please enter the Patient id";
                        this.EmailAlertpopup.open();
                        this.loading = false;
                    }
                    else {
                        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                    }

                }

            }
            else {
                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            }

            this._bookingService.PayLaterAppointmentSave(this.generalBooking, userData)
                .subscribe(
                p => {
                    if (p != null && p == "Success") {
                        this.paylaterBookingStatus = true;
                        this.paylaterPopup.open();
                    }

                    else if (p == "Error") {
                        this.paylaterBookingStatus = false;
                    }
                },
                err => {
                    console.log("Error while getting data...");
                });
        }

        else {
            this.slotErrorMessage = "YES";
        }
    }

    PaylaterPopupClose() {
        this.paylaterPopup.close();
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/searchscreen/Component/SearchScreen.Component.ts